import { defaultStatus } from "../../screen/constant/defaultStatus";
import {
  WHOLESALER_PRODUCT_ADD_REQUEST,
  WHOLESALER_PRODUCT_ADD_SUCCESS,
  WHOLESALER_PRODUCT_ADD_FAILURE,
  WHOLESALER_PRODUCT_EDIT_REQUEST,
  WHOLESALER_PRODUCT_EDIT_SUCCESS,
  WHOLESALER_PRODUCT_EDIT_FAILURE,
  WHOLESALER_PRODUCT_VIEW_REQUEST,
  WHOLESALER_PRODUCT_VIEW_SUCCESS,
  WHOLESALER_PRODUCT_VIEW_FAILURE,
  WHOLESALER_PRODUCT_VIEW_ALL_REQUEST,
  WHOLESALER_PRODUCT_VIEW_ALL_SUCCESS,
  WHOLESALER_PRODUCT_VIEW_ALL_FAILURE,
  WHOLESALER_PRODUCT_DELETE_REQUEST,
  WHOLESALER_PRODUCT_DELETE_SUCCESS,
  WHOLESALER_PRODUCT_DELETE_FAILURE,
  WHOLESALER_PRODUCT_RESET_STATE,
  WHOLESALER_PRODUCT_SEARCH_REQUEST,
  WHOLESALER_PRODUCT_SEARCH_FAILURE,
  WHOLESALER_PRODUCT_SEARCH_SUCCESS,
  WHOLESALER_PRODUCT_VIEW_WHOLESALERID_FAILURE,
  WHOLESALER_PRODUCT_VIEW_WHOLESALERID_SUCCESS,
  WHOLESALER_PRODUCT_VIEW_WHOLESALERID_REQUEST,
  WHOLESALER_PRODUCT_VIEW_WHOLESALERID_SEARCH_REQUEST,
  WHOLESALER_PRODUCT_VIEW_WHOLESALERID_SEARCH_SUCCESS,
  WHOLESALER_PRODUCT_VIEW_WHOLESALERID_SEARCH_FAILURE,
} from "./WholesalerProductTypes";

const initialState = {
  //Product
  addWholesalerProduct: { ...defaultStatus },
  editWholesalerProduct: { ...defaultStatus },
  deleteWholesalerProduct: { ...defaultStatus },
  viewWholesalerProduct: { ...defaultStatus },
  viewWholesalerProductByWholesalerId: { ...defaultStatus },
  viewWholesalerProductSearchByWholesalerId: { ...defaultStatus },
  viewWholesalerAllProducts: { ...defaultStatus },
  viewAllSearchWholesalerProducts: { ...defaultStatus },
};

const WholesalerProductReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    //Wholesaler Product Add
    case WHOLESALER_PRODUCT_ADD_REQUEST:
      return {
        ...state,
        addWholesalerProduct: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case WHOLESALER_PRODUCT_ADD_SUCCESS:
      return {
        ...state,
        addWholesalerProduct: { ...defaultStatus, success: true, ...payload },
      };
    case WHOLESALER_PRODUCT_ADD_FAILURE:
      return {
        ...state,
        addWholesalerProduct: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    //Wholesaler Product Edit
    case WHOLESALER_PRODUCT_EDIT_REQUEST:
      return {
        ...state,
        editWholesalerProduct: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case WHOLESALER_PRODUCT_EDIT_SUCCESS:
      return {
        ...state,
        editWholesalerProduct: { ...defaultStatus, success: true, ...payload },
      };
    case WHOLESALER_PRODUCT_EDIT_FAILURE:
      return {
        ...state,
        editWholesalerProduct: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    //Wholesaler Product View
    case WHOLESALER_PRODUCT_VIEW_REQUEST:
      return {
        ...state,
        viewWholesalerProduct: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case WHOLESALER_PRODUCT_VIEW_SUCCESS:
      return {
        ...state,
        viewWholesalerProduct: { ...defaultStatus, success: true, ...payload },
      };
    case WHOLESALER_PRODUCT_VIEW_FAILURE:
      return {
        ...state,
        viewWholesalerProduct: {
          ...defaultStatus,
          error: true,
          inProgress: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    //Wholesaler Product View By Wholesaler Id
    case WHOLESALER_PRODUCT_VIEW_WHOLESALERID_REQUEST:
      return {
        ...state,
        viewWholesalerProductByWholesalerId: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case WHOLESALER_PRODUCT_VIEW_WHOLESALERID_SUCCESS:
      return {
        ...state,
        viewWholesalerProductByWholesalerId: {
          ...defaultStatus,
          success: true,
          ...payload,
        },
      };
    case WHOLESALER_PRODUCT_VIEW_WHOLESALERID_FAILURE:
      return {
        ...state,
        viewWholesalerProductByWholesalerId: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    //Wholesaler Search Product View By Wholesaler Id
    case WHOLESALER_PRODUCT_VIEW_WHOLESALERID_SEARCH_REQUEST:
      return {
        ...state,
        viewWholesalerProductSearchByWholesalerId: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case WHOLESALER_PRODUCT_VIEW_WHOLESALERID_SEARCH_SUCCESS:
      return {
        ...state,
        viewWholesalerProductSearchByWholesalerId: {
          ...defaultStatus,
          success: true,
          data: payload?.products,
          totalRecords: payload?.totalRecords,
        },
      };
    case WHOLESALER_PRODUCT_VIEW_WHOLESALERID_SEARCH_FAILURE:
      return {
        ...state,
        viewWholesalerProductSearchByWholesalerId: {
          ...defaultStatus,
          error: true,
          inProgress: false,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    //Wholesaler Product View All
    case WHOLESALER_PRODUCT_VIEW_ALL_REQUEST:
      return {
        ...state,
        viewAllWholesalerProducts: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case WHOLESALER_PRODUCT_VIEW_ALL_SUCCESS:
      return {
        ...state,
        viewAllWholesalerProducts: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case WHOLESALER_PRODUCT_VIEW_ALL_FAILURE:
      return {
        ...state,
        viewAllWholesalerProducts: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    //Wholesaler Search Product View All
    case WHOLESALER_PRODUCT_SEARCH_REQUEST:
      return {
        ...state,
        viewAllSearchWholesalerProducts: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case WHOLESALER_PRODUCT_SEARCH_SUCCESS:
      return {
        ...state,
        viewAllSearchWholesalerProducts: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case WHOLESALER_PRODUCT_SEARCH_FAILURE:
      return {
        ...state,
        viewAllSearchWholesalerProducts: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    //Wholesaler Product Delete
    case WHOLESALER_PRODUCT_DELETE_REQUEST:
      return {
        ...state,
        deleteWholesalerProduct: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case WHOLESALER_PRODUCT_DELETE_SUCCESS:
      return {
        ...state,
        deleteWholesalerProduct: {
          ...defaultStatus,
          success: true,
          ...payload,
        },
      };
    case WHOLESALER_PRODUCT_DELETE_FAILURE:
      return {
        ...state,
        deleteWholesalerProduct: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    //Reset
    case WHOLESALER_PRODUCT_RESET_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default WholesalerProductReducer;
